export function dataInRequest(params = {}) {
  return {
    type: '@alteracaoCentroCusto/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function failedRequest() {
  return {
    type: '@alteracaoCentroCusto/FAILED_REQUEST',
  };
}

export function storeData(data, params) {
  return {
    type: '@alteracaoCentroCusto/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@alteracaoCentroCusto/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRemove(params) {
  return {
    type: '@alteracaoCentroCusto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@alteracaoCentroCusto/RECORD_FILTERING',
    payload: { params },
  };
}
